module.exports = __webpack_public_path__ + "img/607f6e0.png";